import { Body, Button, Stack } from "@biom3/react";

type EOAWalletDisconnectProps = {
  walletAddress: string;
  disconnect: () => Promise<void>;
};

export const EOAWalletDisconnect = ({
  walletAddress,
  disconnect,
}: EOAWalletDisconnectProps) => {
  const truncatedAddress = `${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`;

  return (
    <Stack
      direction="column"
      gap="base.spacing.x2"
      sx={{
        mb: "base.spacing.x4",
        p: "base.spacing.x3",
        bg: "base.color.translucent.emphasis.100",
        borderRadius: "base.borderRadius.x3",
      }}
    >
      <Body size="small" color="secondary">
        Connected with EOA wallet
      </Body>
      <Body size="small" weight="bold">
        {truncatedAddress}
      </Body>
      <Button
        size="small"
        variant="tertiary"
        onClick={disconnect}
        testId="eoa-disconnect-btn"
      >
        Disconnect
      </Button>
    </Stack>
  );
};
